/*-----------------------------------------------------------------
- FAQ
-----------------------------------------------------------------*/
export default {
    title         : 'سوالات متداول',
    title_category: 'دسته‌بندی سوال‌ها',
    feature_title : 'چرا از خشکبار بانمک خرید کنیم؟',
    
};
